import React from 'react';
import './ProjectsPopup.css';

const ProjectsPopup = ({ projects, onClose, onProjectSelected, currentProject, onDeleteProject }) => {
  return (
    <div className="projects-popup-overlay" onClick={onClose}>
      <div className="projects-popup" onClick={(e) => e.stopPropagation()}>
        <div className="projects-popup-header">
          <h3>Projects</h3>
          <button className="close-button" onClick={onClose}>
            <span className="material-symbols-outlined">close</span>
          </button>
        </div>
        <div className="projects-list">
          {projects.map((project) => (
            <div
              key={project.id}
              className={`project-item ${project.id === currentProject ? 'selected' : ''}`}
              onClick={() => onProjectSelected(project.id)}
            >
              <span className="project-name">{project.name}</span>
              <button
                className="delete-button"
                onClick={(e) => {
                  e.stopPropagation();
                  onDeleteProject(project);
                  onClose();
                }}
              >
                <span className="material-symbols-outlined">delete</span>
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProjectsPopup;
